package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class UserWarehouses(
    val userId: Int,
    val warehouses: List<String>,
)